import Account from "@/helper/AccountHelper.js";
import ConfigManager from "@/config/ConfigManager.js";
import BzbsApi from "@/core/Http/BzbsApi.js";
import { map } from "rxjs/operators";
import Vue from "vue";
/**
 * @function getFriendLink
 * @function getUserBadges
 */

export default {
    config: function() {
        return Vue.bzbsConfig;
    },
    GetMissionBadges: function() {
        const token = Account.getToken();
        const url = ConfigManager.getApiUrl() + "/profile/me/badges";
        var params = {
            group: "mission_buy"
        };
        return BzbsApi.connectBzbsGet(url, token, params).pipe(
            map(res => {
                return res.data;
            })
        );
    },
    GetTabBlob() {
        const url = `${ConfigManager.getBlobUrl()}/nestle/nescafe_streetcafe/MissionHome/Mission_Home.json`;
        return new Promise((resolve, reject) => {
            BzbsApi.GetBzbsGetBlob(url)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    GetMissionBlob(traceplanId) {
        const url = `${ConfigManager.getBlobUrl()}/nestle/nescafe_streetcafe/Badges/Badges_image/${traceplanId}.png`;
        return new Promise((resolve, reject) => {
            BzbsApi.GetBzbsGetBlob(url)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    console.log(error);
                    reject(error);
                });
        });
    },
    GetBadgeDetailBlob() {
        const url = `${ConfigManager.getBlobUrl()}/nestle/nescafe_streetcafe/Badges/Badges_Detail/Badges_Detail.json`;
        return new Promise((resolve, reject) => {
            BzbsApi.GetBzbsGetBlob(url)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    console.log(error);
                    reject(error);
                });
        });
    },
    GetDetailBlob() {
        const url = `${ConfigManager.getBlobUrl()}/nestle/nescafe_streetcafe/Collections/Collection_Detail.json?v=${new Date().getTime()}`;
        return new Promise((resolve, reject) => {
            BzbsApi.GetBzbsGetBlob(url)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    console.log(error);
                    reject(error);
                });
        });
    },
    GetBlob(campaignId) {
        const url = `${ConfigManager.getBlobUrl()}/nestle/nescafe_streetcafe/Images/menu_drink/${campaignId}.png`;
        return new Promise((resolve, reject) => {
            BzbsApi.GetBzbsGetBlob(url)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    GetMissionBadgeImage(campaignId) {
        const url = `${ConfigManager.getBlobUrl()}/nestle/nescafe_streetcafe/Badges/Badges_image/${campaignId}.png`;
        return new Promise((resolve, reject) => {
            BzbsApi.GetBzbsGetBlob(url)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    console.log(error);
                    reject(error);
                });
        });
    },
    GetCafeLocation(distance, center) {
        const agentcyId = ConfigManager.getAgencyId();
        const token = Account.getToken();
        //test distance
        let params = {
            agencyId: agentcyId,
            require_campaign: false,
            distance: distance,
            center: center
        };
        const url = `${ConfigManager.getApiUrl()}/place`;
        return BzbsApi.connectBzbsGet(url, token, params).pipe(
            map(res => {
                return res.data;
            })
        );
    },
    GetUserlevleConfig() {
        const url =
            ConfigManager.getBlobUrl() +
            "/nestle/nescafe_streetcafe/Collections/config_userlevel.json";
        return new Promise((resolve, reject) => {
            BzbsApi.GetBzbsGetBlob(url)
                .then(response => {
                    // console.log(response);
                    resolve(response);
                })
                .catch(error => {
                    console.log(error);
                    reject(error);
                });
        });
    }
};
